import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'
import { wagmiConfig } from '../util/Managed'
import EmbeddedPresale from '../views/EmbeddedPresale'
import { BrowserRouter } from 'react-router-dom'

declare global {
  interface Window {
    LoadPresale: (elementId: string, presaleId: string) => void
  }
}

console.info(`
██████╗  █████╗ ██████╗  ██████╗ ███╗   ███╗
██╔══██╗██╔══██╗██╔══██╗██╔═══██╗████╗ ████║
██████╔╝███████║██║  ██║██║   ██║██╔████╔██║
██╔══██╗██╔══██║██║  ██║██║   ██║██║╚██╔╝██║
██║  ██║██║  ██║██████╔╝╚██████╔╝██║ ╚═╝ ██║
╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝  ╚═════╝ ╚═╝     ╚═╝
Welcome to Radom!
Build: ${process.env.RADOM_BUILD_VERSION}
`)

const queryClient = new QueryClient()

window.LoadPresale = (elementId, presaleId) => {
  const element = document.getElementById(elementId)
  if (!element) {
    console.error(`Element with id ${elementId} not found`)
    return
  }
  const root = createRoot(element)
  root.render(<WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <EmbeddedPresale paymentLinkId={presaleId} />
      </BrowserRouter>
    </QueryClientProvider>
  </WagmiProvider>
  )
}
